import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

class TextArea extends Component {
  render() {
    const {
      placeholder = '',
      helperText = '',
      value,
      onChange = () => {},
      classes
    } = this.props

    return (
      <TextField
        fullWidth
        id={'outlined-multiline-flexible'}
        label={placeholder}
        multiline
        rowsMax={'4'}
        value={value}
        onChange={event => onChange(event.target.value)}
        className={classes.textField}
        margin={'normal'}
        helperText={helperText}
        variant={'outlined'}
        InputLabelProps={{
          FormLabelClasses: {
            root: classes.cssLabel,
            focused: classes.cssFocused
          }
        }}
      />
    )
  }
}

const Styles = {
  textField: {},
  cssLabel: {
    '&$cssFocused': {
      color: '#289e64'
    }
  },
  cssFocused: {}
}

export default withStyles(Styles)(TextArea)



// WEBPACK FOOTER //
// ./src/components/common/TextArea.js